"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CookieModule } from 'ngx-cookie';
import { AUTH_CONFIG } from './auth.config';
import { Auth } from './auth.service';
var AuthModule = (function () {
    function AuthModule() {
    }
    AuthModule_1 = AuthModule;
    AuthModule.initialize = function (config) {
        return {
            ngModule: AuthModule_1,
            providers: [Auth, { provide: AUTH_CONFIG, useValue: config }],
        };
    };
    AuthModule = AuthModule_1 = __decorate([
        NgModule({
            imports: [HttpClientModule, CookieModule],
        })
    ], AuthModule);
    return AuthModule;
    var AuthModule_1;
}());
export { AuthModule };



// WEBPACK FOOTER //
// auth.module.js